import serverPath from "./server.path";

const serverConfigs = {
    serverPath
}

export default serverConfigs;